/**
 * What the numbers on screen are pinned to. Shown on every view, because a
 * price without its catalog version and observation context is not reproducible.
 */

import { ageNow, formatInstant } from "../lib/format.ts";

export interface ContextBarProps {
  readonly catalogRevisionId: string | null;
  readonly observationSequence: number;
  readonly observationCutoffUtc: string;
  readonly atUtc?: string;
  readonly freshness?: string;
  readonly onPin?: () => void;
  readonly pinned?: boolean;
}

export function ContextBar(props: ContextBarProps): React.JSX.Element {
  return (
    <div className="context-bar">
      <span>
        catalog <code>{props.catalogRevisionId ?? "none published"}</code>
      </span>
      <span>
        observation <code>#{props.observationSequence}</code> at{" "}
        <code>{formatInstant(props.observationCutoffUtc)}</code>{" "}
        {/* Nothing else on screen says the catalog has stopped being updated. */}
        <span className="context-bar__age">({ageNow(props.observationCutoffUtc)})</span>
      </span>
      {props.atUtc ? (
        <span>
          as of <code>{formatInstant(props.atUtc)}</code>
        </span>
      ) : null}
      {props.freshness ? (
        <span>
          freshness <code>{props.freshness}</code>
        </span>
      ) : null}
      {props.onPin && props.catalogRevisionId ? (
        <button type="button" className="button" onClick={props.onPin}>
          {props.pinned ? "Unpin this version" : "Pin this version to the URL"}
        </button>
      ) : null}
    </div>
  );
}
